import { useEffect } from "react";
import { useConferenceContext } from "../../hooks/useConferenceContext/useConferenceContext";
import { useConferencePlaybackContext } from "../../hooks/useConferencePlaybackContext/useConferencePlaybackContext";

export const ConferenceGlobalAPI = () => {
	const { isConnecting, isConnected, connect, disconnect } = useConferenceContext();
	const playback = useConferencePlaybackContext();

	useEffect(() => {
		window.playbackProvider = { ...(window as any).playbackProvider, ...playback };

		window.conferenceProvider = {
			isConnecting: () => !!isConnecting,
			isConnected:  () => !!isConnected,
			connect: async (token: string) => connect(token),
			disconnect: async () => disconnect()
		};

		return () => {
			delete (window as any).conferenceProvider;
		};
	}, [playback, isConnecting, isConnected, connect, disconnect]);

	return null;
};
